import { alertasApi } from '../alertas/alertasObra.api';

/* Combo "IA de obra" / IA Pro: Buscador de obra (ex Maquinaria), Entradas y salidas, Materiales, Acopio y Alertas de
   entregas. USD 20/mes por cámara, 30 días gratis (lo activado antes del 25/10/2026 sigue en USD 15). El estado sale del
   backend (/api/alertas/combo-ia/estado) y se guarda un minuto por cámara para no pedirlo en cada pestaña.
   Seguridad e Higiene (ex "IA") es un ADICIONAL sobre IA Pro: USD 10/mes por cámara, 30 días gratis, se activa aparte
   (/api/alertas/seguridad/*). */

export const COMBO = {
  nombre: 'IA Pro',
  precioUsd: 20,
  diasPrueba: 30,
};

/** Pestañas de CameraDashboard que pasan por la puerta del combo ("Maquinaria" = nombre viejo de "Buscador de obra"). */
/** Ítems del menú con la insignia PRO (las pestañas del combo y Alertas, donde están las alertas de entregas). */
export const ITEMS_PRO = ['Buscador de obra', 'Maquinaria', 'Entradas y salidas', 'Materiales', 'Acopio', 'Alertas'];
export const PESTANAS_COMBO = ['Buscador de obra', 'Maquinaria', 'Entradas y salidas', 'Materiales', 'Acopio'];
/** Adicional sobre IA Pro (insignia PRO+ en el menú). */
export const SEGURIDAD = { nombre: 'Seguridad e Higiene', precioUsd: 10, diasPrueba: 30 };
export const ITEMS_PRO_PLUS = ['Seguridad e Higiene'];
/** Módulos que trae IA Pro (se explican al activarlo). */
export const MODULOS_PRO = ['Buscador de obra', 'Entradas y salidas', 'Materiales', 'Acopio', 'Alertas de entregas'];

const cache = new Map(); // feedId -> { at, p }
const TTL = 60_000;

export function estadoCombo(feedId, { refrescar = false } = {}) {
  const c = cache.get(feedId);
  if (!refrescar && c && Date.now() - c.at < TTL) return c.p;
  const p = alertasApi.comboEstado(feedId).catch((e) => { cache.delete(feedId); throw e; });
  cache.set(feedId, { at: Date.now(), p });
  return p;
}
export const olvidarCombo = (feedId) => cache.delete(feedId);

const cacheSeg = new Map();
export function estadoSeguridad(feedId, { refrescar = false } = {}) {
  const c = cacheSeg.get(feedId);
  if (!refrescar && c && Date.now() - c.at < TTL) return c.p;
  const p = alertasApi.seguridadEstado(feedId).catch((e) => { cacheSeg.delete(feedId); throw e; });
  cacheSeg.set(feedId, { at: Date.now(), p });
  return p;
}
export const olvidarSeguridad = (feedId) => cacheSeg.delete(feedId);

/** Solo local (/__preview-*): ?seguridad=activo|prueba|no fuerza el estado del adicional (con ?combo=no queda requierePro). */
export function seguridadForzada() {
  if (process.env.NODE_ENV !== 'development') return null;
  if (!window.location.pathname.startsWith('/__preview-')) return null;
  const q = new URLSearchParams(window.location.search);
  const v = q.get('seguridad');
  if (!['activo', 'prueba', 'no'].includes(v)) return null;
  const sinPro = q.get('combo') === 'no';
  return { estado: sinPro ? 'no' : v, requierePro: sinPro, diasRestantes: v === 'prueba' ? 27 : null, priceUsd: SEGURIDAD.precioUsd, trialDays: SEGURIDAD.diasPrueba, simulado: true };
}

/** Solo local (/__preview-*): ?combo=activo|prueba|no fuerza el estado, sin backend. */
export function estadoForzado() {
  if (process.env.NODE_ENV !== 'development') return null;
  if (!window.location.pathname.startsWith('/__preview-')) return null;
  const v = new URLSearchParams(window.location.search).get('combo');
  if (!['activo', 'prueba', 'no'].includes(v)) return null;
  return {
    estado: v,
    diasRestantes: v === 'prueba' ? 23 : null,
    priceUsd: COMBO.precioUsd,
    trialDays: COMBO.diasPrueba,
    contratado: v !== 'no',
    feedIncluido: v !== 'no',
    simulado: true,
  };
}
